(function () {
  'use strict';

  var marker = document.querySelector('[data-bfe-lenis-home-capture]');
  if (!marker) return;

  var desktopQuery = window.matchMedia('(min-width: 700px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lenis = null;

  function shouldRun() {
    return desktopQuery.matches && !reducedMotionQuery.matches && typeof window.Lenis === 'function';
  }

  function enable() {
    if (lenis || !shouldRun()) return;

    lenis = new window.Lenis({
      autoRaf: true,
      duration: 1.15,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 0.9,
      anchors: true,
      prevent: function (node) {
        return !!node.closest('dialog, [role="dialog"], .drawer, .popover, [data-lenis-prevent]');
      }
    });

    document.documentElement.setAttribute('data-bfe-lenis-capture', 'active');
    window.__bfeLenisCapture = lenis;
  }

  function disable() {
    if (!lenis) return;
    lenis.destroy();
    lenis = null;
    delete window.__bfeLenisCapture;
    document.documentElement.removeAttribute('data-bfe-lenis-capture');
  }

  function sync() {
    if (shouldRun()) enable();
    else disable();
  }

  desktopQuery.addEventListener('change', sync);
  reducedMotionQuery.addEventListener('change', sync);
  sync();
})();
